export default [{
    header: 'Testimonios',
    icon: 'StarIcon',
    children: [{
        title: 'Lista',
        route: 'testimonials',
        icon: 'ListIcon'
    }]
}];
